import {
    Bed,
    Calendar,
    Plane,
    FileText,
    FerrisWheel,
    CarTaxiFront,
    MicVocal,
    ClockArrowDown,
    CupSoda,
    type LucideIcon,
} from "lucide-react";

/**
 * L'icona di ogni tipo di attivita', separata da `activity-configs.model`.
 *
 * Sta in un modulo suo perche' `activity-configs.model` importa tutte le modali del
 * builder (RateHawk, Duffel, allegati...): chi vuole solo disegnare un'icona — un
 * riepilogo, un'anteprima, una modale globale sempre montata — non deve tirarsi
 * dietro quel grafo. `ACTIVITIES` legge da qui, quindi la scelta dell'icona resta
 * in un posto solo.
 */
export const ACTIVITY_TYPE_ICONS: Record<string, LucideIcon> = {
    accommodation: Bed,
    accommodationOut: ClockArrowDown,
    activity: FerrisWheel,
    flight: Plane,
    transportation: CarTaxiFront,
    'food-drinks': CupSoda,
    events: MicVocal,
    notes: FileText,
};

/** Icona del tipo indicato, con il fallback usato ovunque nel builder (calendario). */
export const activityTypeIconComponent = (type?: string | null): LucideIcon =>
    (type && ACTIVITY_TYPE_ICONS[type]) || Calendar;

interface ActivityTypeIconProps {
    type?: string | null;
    className?: string;
}

/** L'icona gia' renderizzata, nella misura standard delle liste. */
export const ActivityTypeIcon = ({ type, className = "h-4 w-4" }: ActivityTypeIconProps) => {
    const Icon = activityTypeIconComponent(type);
    return <Icon className={className} />;
};
